module.exports = __webpack_public_path__ + "static/media/5n.b4a9ac95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/5n.svg
// module id = 154
// module chunks = 0